export enum TimelineBoApproval {
  D_BO_DP_N2 = 'D_BO_DP_N2',
  D_BO_DP_N1 = 'D_BO_DP_N1',
  D_BO_G_OPEA = 'D_BO_G_OPEA',
}
